export default __webpack_public_path__ + "static/media/avatar_trex2.29cc46dd.mp3";